<template>  
  <div class="XR-Result">
    <div class="weui_msg">
        <div class="weui_icon_area"><i :class="icon" :style="{background:bgColor}"></i></div>
        <div class="weui_text_area">
            <h2 class="weui_msg_title">{{msg}}</h2>
            <p class="weui_msg_desc">{{content}}</p>
        </div>
        <div class="weui_opr_area">
          <mu-raised-button to="/usercenter/index" label="返回个人中心" class="yes" fullWidth></mu-raised-button>
          <mu-raised-button to="/" label="返回首页" class="failed" primary fullWidth></mu-raised-button>
        </div>
        <!-- <div class="weui_extra_area">
            <a href="">查看详情</a>
        </div> -->
    </div>
  </div>
</template>

<script>
export default {
  name : 'XR-Result',
  data () {
    return {
    }
  },
  props:{
    icon:String,
    msg: String,
    content: String,
    bgColor : String
  }
}
</script>

<style>
.XR-Result .weui_msg {
  padding-top: 66px;
  text-align: center;
}
.XR-Result .weui_icon_area {
  margin-bottom: 30px;
}
.XR-Result .weui_icon_area i {
  font-size: 50px;
  width: 80px;
  height: 80px;
  text-align: center;
  line-height: 80px;
  background: #24E3A0;
  color:white;
  border-radius: 50%;
}

.XR-Result .weui_text_area {
  margin-bottom: 25px;
  padding:0 20px;
}
.XR-Result .weui_msg_title {
  margin-bottom: 5px;
  font-weight: 400;
  font-size: 20px;
}
.XR-Result .weui_msg_desc {
  font-size: 14px;
  color: #888;
}

.XR-Result .weui_opr_area {
  margin-bottom: 25px;
}
.XR-Result .weui_opr_area .yes{
  width: 95%;
  height: 50px;
}
.XR-Result .weui_opr_area .failed{
  width: 95%;
  height: 50px;
  margin-top: 10px;
}


.XR-Result .weui_extra_area {
  margin-bottom: 15px;
  font-size: 14px;
  color: #888;
}
.XR-Result .weui_extra_area a{color: #61749B;}

.XR-Result .weui_extra_area {
  position: fixed;
  left: 0;
  bottom: 0;
  width: 100%;
  text-align: center;
}

</style>



// WEBPACK FOOTER //
// src/components/result/result.vue